import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Form } from 'react-final-form';

import SecurityPageWrapper from '../security-page-wrapper/SecurityPageWrapper';
import validate from '../../utils/validate';
import { forgotPasswordYupValidation } from '../validation';
import ForgotPasswordForm from './ForgotPasswordForm';
import { sendForgotPasswordOtp } from '../../redux/security/securityActions';

const ForgotPassword = () => {
  const dispatch = useDispatch();
  const forgotPasswordInitialValues = {
    username: '',
  };

  const handleForgotPassword = useCallback(
    (values) => {
      dispatch(sendForgotPasswordOtp(values));
    },
    [dispatch],
  );

  return (
    <SecurityPageWrapper>
      <Form
        initialValues={forgotPasswordInitialValues}
        onSubmit={handleForgotPassword}
        validate={(values) => validate(values, forgotPasswordYupValidation())}
        subscription={{ submitting: true, pristine: true }}
        render={({ handleSubmit }) => <ForgotPasswordForm handleSubmit={handleSubmit} />}
      />
    </SecurityPageWrapper>
  );
};

export default ForgotPassword;
